<template>
  <div class="root">
    <div class="header-box add-bg">
      <div class="c-header">
        <div class="header-logo">
          <a href="/">
            <img src="./images/header-logo-orange-xd.png">
          </a>
        </div>
        <!-- <div class="credit">
        <a href="javascript:;" @click.prevent="showQrcode">征信查询</a>
        <div class="qrcode-box">
          <i class="close-btn" @click="closeQrcode"></i>
          <div class="qrcode-content">
            <p>风险信用不可小觑</p>
            <p>您有一份征信报告待查看</p>
            <div class="qrcode" id="qrcode" ref="qrcode"></div>
            <div class="foot">扫码即刻查征信</div>
          </div>
        </div>
      </div> -->
        <ul class="nav">
          <li v-for="(item,index) in navList" :key="index">
            <a @click="goUrl(item.url)" :class="{ active:index==currentPage}">{{item.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="banner">
      <div class="banner-content"></div>
    </div>
    <div class="content">
      <p>简历投递至: <span>jrzp@bajiegroup.com</span></p>
      <h2>招聘岗位 <i></i></h2>
      <ul class="recruit" style="text-align:center;" v-if="jobList.length === 0">
        暂无招聘信息
      </ul>
      <ul class="recruit" v-else>
        <li :class="getClass(index)" v-for="(item,index) in jobList" :key="index" @click="goDetail(item.positionName)">
          <h2>{{item.positionName}}
            <img v-if="item.isUrgent" src="./images/icon-urgent.png">
          </h2>
          <p>{{item.positionType}} | {{item.workPlace}}</p>
        </li>
      </ul>
      <div class="more-jobs">
        <a href="/#/joinUs">更多招聘</a>
      </div>
      <h2>公司福利 <i></i></h2>
    </div>
    <div class="welfare">
      <div class="welfare-content">
        <div class="welfare-item right-margin bottom-margin">
          <dl>
            <dt>
              <img src="./images/icon-marry.png" alt="">
            </dt>
            <dl class="title">结婚啦</dl>
            <dl class="text">法定婚假/婚礼礼金</dl>
          </dl>
        </div>
        <div class="welfare-item right-margin bottom-margin">
          <dl>
            <dt>
              <img src="./images/icon-baby.png" alt="">
            </dt>
            <dl class="title">生宝宝了</dl>
            <dl class="text">产检假/产假</dl>
            <dl class="text">陪假/哺乳/生育礼金</dl>
          </dl>
        </div>
        <div class="welfare-item right-margin bottom-margin">
          <dl>
            <dt>
              <img src="./images/icon-holiday.png" alt="">
            </dt>
            <dl class="title">年假</dl>
            <dl class="text">每年可享受5~10天年假</dl>
          </dl>
        </div>
        <div class="welfare-item bottom-margin">
          <dl>
            <dt>
              <img src="./images/icon-check.png" alt="">
            </dt>
            <dl class="title">年度健康体检</dl>
            <dl class="text">每年8~9月定期体检</dl>
          </dl>
        </div>
        <div class="welfare-item right-margin">
          <dl>
            <dt>
              <img src="./images/icon-birth.png" alt="">
            </dt>
            <dl class="title">过生日啦</dl>
            <dl class="text">生日祝福/生日礼品</dl>
          </dl>
        </div>
        <div class="welfare-item right-margin">
          <dl>
            <dt>
              <img src="./images/icon-welfare.png" alt="">
            </dt>
            <dl class="title">五险一金</dl>
            <dl class="text">在工作地缴纳</dl>
          </dl>
        </div>
        <div class="welfare-item right-margin">
          <dl>
            <dt>
              <img src="./images/icon-sick.png" alt="">
            </dt>
            <dl class="title">生病了</dl>
            <dl class="text">病假/医疗期/住院关爱礼金</dl>
          </dl>
        </div>
        <div class="welfare-item">
          <dl>
            <dt>
              <img src="./images/icon-gone.png" alt="">
            </dt>
            <dl class="title">亲属去世</dl>
            <dl class="text">丧假/慰问金</dl>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import job from "@/global/js/staticData/job";
import $ from "jquery";
import QRCode from "qrcodejs2";
export default {
  name: "joinus-main",
  data() {
    return {
      navList: [
        {
          name: "联系我们",
          url: "/contactUs",
        },
        {
          name: "加入我们",
          url: "/joinUsMain",
        },
        {
          name: "公司公告",
          url: "/announcementList",
        },
        {
          name: "场景服务",
          url: "/sceneService",
        },
        {
          name: "关于八戒小贷",
          url: "/aboutUs",
        },
        {
          name: "首页",
          url: "/index",
        },
      ],
      currentPage: 1,
      jobList: [],
    };
  },
  mounted() {
    this.$bus.$emit("ready");
    if (job.jobList.length <= 9) {
      this.jobList = job.jobList;
    } else {
      this.jobList = job.jobList.slice(0, 9);
    }
  },
  methods: {
    goUrl(url) {
      this.$router.push(url);
    },
    getClass(index) {
      if (index === 0 || index === 1 || index === 3 || index === 4) {
        return "right-margin bottom-margin";
      }
      if (index === 2 || index === 5 || index === 8) {
        return "bottom-margin";
      }
      if (index === 6 || index === 7) {
        return "right-margin";
      }
    },
    goDetail(name) {
      this.$router.push({
        path: "/joinUsDetail",
        query: {
          name: name,
        },
      });
    },
    showQrcode() {
      $(".qrcode").html("");
      let qrcode = new QRCode("qrcode", {
        width: 154, // 设置宽度
        height: 154, // 设置高度
        text: "https://m.tianxiaxinyong.cn/cooperation/crp-v2/per-detail.html?channel=K3lRa1Z6WE9aY2Iveng0VHNoN2d3Zz09",
      });
      $(".qrcode-box").slideDown(300, "linear", function () {
        $(".qrcode-content").fadeIn(500);
      });
    },
    closeQrcode() {
      $(".qrcode-box").fadeOut();
      $(".qrcode-content").hide();
    },
  },
};
</script>
<style scoped rel="stylesheet/less" lang="less">
@import "..\..\..\global\css\mixin\mixin.less";
.root {
  background-color: #f2f2f2;
}
.header-box {
  width: 100%;
  height: 104px;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 999;
  &.add-bg {
    background: url("./images/white-header-bg.png") no-repeat top center;
  }
}
.c-header {
  background-color: #fff;
  font-size: 22px;
  width: 1200px;
  height: 80px;
  line-height: 80px;
  // overflow: hidden;
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -600px;
  z-index: 999;
  background-color: transparent;
  .header-logo {
    float: left;
    width: 105px;
    height: 80px;
    text-align: center;
    position: relative;
    img {
      width: 166px;
      vertical-align: middle;
      // position: relative;
      // bottom: 3px;
    }
  }
  .credit {
    float: right;
    width: 124px;
    height: 80px;
    text-align: center;
    position: relative;
    margin-left: 55px;
    font-size: 16px;
    a {
      position: absolute;
      width: 124px;
      height: 40px;
      line-height: 40px;
      left: 0;
      top: 20px;
      color: #fff;
      background: url("./images/credit.png") no-repeat;
    }
    .qrcode-box {
      display: none;
      position: absolute;
      width: 264px;
      height: 447px;
      top: 60px;
      left: -70px;
      box-sizing: border-box;
      padding: 137px 36px 26px 36px;
      background: url("./images/qrcode-box.png") no-repeat;
      .close-btn {
        position: absolute;
        width: 20px;
        height: 20px;
        top: 145px;
        right: 40px;
        background: url("./images/qrcode-close.png") no-repeat;
        cursor: pointer;
      }
      .qrcode-content {
        width: 160px;
        height: 260px;
        padding: 24px 16px 0px 16px;
        display: none;
        p {
          height: 20px;
          line-height: 20px;
          color: #000000;
          font-size: 12px;
        }
        .qrcode {
          width: 154px;
          height: 154px;
          padding: 4px;
          border: 2px solid #ffc39c;
          margin-top: 5px;
        }
        .foot {
          width: 155px;
          height: 38px;
          margin: 0 auto;
          line-height: 38px;
          text-align: center;
          background: url("./images/qrcode-line.png") no-repeat center;
          color: #000000;
          font-size: 12px;
        }
      }
    }
  }
  .nav {
    li {
      float: right;
      cursor: pointer;
      margin-left: 55px;
      height: 80px;
      a {
        color: #666;
        font-size: 16px;
        padding: 5px 0;
        &:hover {
          color: #333333;
          border-bottom: 2px solid #ff4300;
        }
        &.active {
          color: #333333;
          border-bottom: 2px solid #ff4300;
        }
      }
    }
  }
}
.banner {
  width: 100%;
  height: 527px;
  padding-top: 80px;
  .banner-content {
    width: 100%;
    height: 527px;
    background: url("./images/join-us-bg.png") no-repeat center;
  }
}
.content {
  width: 1200px;
  height: auto;
  padding-top: 100px;
  margin: 0 auto;
  p {
    height: 80px;
    line-height: 80px;
    font-size: 24px;
    color: #333333;
    text-align: center;
    span {
      color: #ff6900;
    }
  }
  h2 {
    color: #333333;
    font-size: 32px;
    height: 60px;
    line-height: 60px;
    position: relative;
    text-align: center;
    i {
      position: absolute;
      width: 80px;
      height: 2px;
      background-color: #e5e5e5;
      left: 50%;
      margin-left: -40px;
      bottom: 0;
    }
  }
  .recruit {
    width: 1200px;
    height: 447px;
    padding-top: 60px;
    li {
      width: 396px;
      height: 145px;
      box-sizing: border-box;
      background-color: #ffffff;
      float: left;
      border-radius: 4px;
      padding: 20px 25px;
      cursor: pointer;
      &:hover {
        background-color: #fafafa;
      }
      &.right-margin {
        margin-right: 6px;
      }
      &.bottom-margin {
        margin-bottom: 6px;
      }
      h2 {
        font-size: 20px;
        font-weight: normal;
        height: 50px;
        line-height: 50px;
        color: #111111;
        text-align: left;
        position: relative;
        img {
          width: 16px;
          height: 18px;
          position: absolute;
          top: 16px;
          right: 0px;
        }
      }
      p {
        font-size: 14px;
        color: #999999;
        height: 30px;
        line-height: 30px;
        text-align: left;
        padding-top: 25px;
      }
    }
  }
  .more-jobs {
    width: 100%;
    height: 43px;
    text-align: center;
    padding-top: 27px;
    padding-bottom: 114px;
    a {
      width: 154px;
      height: 43px;
      line-height: 43px;
      color: #ffffff;
      background-color: #ff6900;
      font-size: 14px;
      display: inline-block;
      &:hover {
        background-color: #faa061;
      }
    }
  }
}
.welfare {
  width: 100%;
  height: 830px;
  margin: 0 auto;
  background: url("./images/dot-bg.png") no-repeat;
  .welfare-content {
    width: 1200px;
    margin: 0 auto;
    height: 632px;
    padding-top: 60px;
    .welfare-item {
      width: 285px;
      height: 306px;
      box-sizing: border-box;
      background-color: #ffffff;
      float: left;
      border-radius: 4px;
      text-align: center;
      &:hover {
        box-shadow: 0px 0px 10px #ddd;
        .title {
          color: #ff6900;
        }
      }
      &.right-margin {
        margin-right: 20px;
      }
      &.bottom-margin {
        margin-bottom: 20px;
      }
      dt {
        height: 140px;
        width: 100%;
        img {
          margin-top: 90px;
        }
      }
      .title {
        color: #333333;
        font-size: 22px;
        height: 70px;
        line-height: 70px;
      }
      .text {
        color: #333333;
        font-size: 16px;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// joinUsMain.vue?79670a72